import { frontendURL } from '../../../helper/URLHelper';
import LeadsIndex from '../laisLeads/pages/LeadsIndex.vue';

export default {
  path: frontendURL('accounts/:accountId/traz-quem-compra'),
  name: 'traz-quem-compra',
  component: LeadsIndex,
};
